module.exports = __webpack_public_path__ + "img/Contacts.6e66f77c.svg";